import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import AddAssistant from "../../../containers/admin/assistants/models/add-assistant";
import ShowAssistantData from "../../../containers/admin/assistants/models/show-assistant-data";
import SearchBar from "../../../containers/admin/assistants/searchbar";
import AssistantsTable from "../../../containers/admin/assistants/table";
import { getAllAssistantsRequest } from "../../../modules/admin-modules/assistants/Actions";

const Assistants = () => {
  const dispatch = useDispatch();
  const model = useSelector((state) => state.model);
  const assistants = useSelector((state) => state.assistants.assistants);
  const isLoading = useSelector((state) => state.assistants.isLoading);
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [createdAssistantData, setCreatedAssistantData] = useState(null);

  useEffect(() => {
    dispatch(getAllAssistantsRequest());
  }, [dispatch]);

  return (
    <Layout>
      <SearchBar setAdd={setAdd} setSelectedData={setSelectedData} assistants={assistants} />
      <AssistantsTable 
        setAdd={setAdd} 
        setSelectedData={setSelectedData}
      />
      <AddAssistant
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
        setCreatedAssistantData={setCreatedAssistantData}
      />
      <ShowAssistantData data={createdAssistantData} />
    </Layout>
  );
};

export default Assistants;

